import { PlatformEnum } from '@panamax/app-state';
import { Order } from '@usf/ngrx-order';

export abstract class OrderShareService {
  protected static readonly CSV_EXTENSION = '.csv';
  abstract isSupported(platformType: PlatformEnum);
  abstract shareCart(order: Order);
  abstract shareOrderConfirmation(order: Order[]);
  abstract shareSubmittedOrder(order: Order[]);

  protected formatDate(date: Date): string {
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    return `${month}${day}${year}`;
  }
}
